import classNames from 'classnames';
import React from 'react';
import { Container } from 'shards-react';

/**
 * Export a spinner component during loading.
 */

const Loading = ({ style, classes }) => {
	const cssCLasses = classNames('d-flex justify-content-center align-items-center', classes);
	return (
		<Container fluid className={cssCLasses} style={style}>
			<span className='spinner-border text-warning' role='status' aria-hidden='true' />
		</Container>
	);
};

export default Loading;
